import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import classNames from 'classnames';
import styles from './options-layout.module.scss';
import { useConfig } from '../../contexts/config-context';
export let NUMBER_OF_COLUMNS = /*#__PURE__*/function (NUMBER_OF_COLUMNS) {
  NUMBER_OF_COLUMNS[NUMBER_OF_COLUMNS["FREE_FLOW"] = 0] = "FREE_FLOW";
  NUMBER_OF_COLUMNS[NUMBER_OF_COLUMNS["ONE"] = 1] = "ONE";
  NUMBER_OF_COLUMNS[NUMBER_OF_COLUMNS["TWO"] = 2] = "TWO";
  NUMBER_OF_COLUMNS[NUMBER_OF_COLUMNS["THREE"] = 3] = "THREE";
  return NUMBER_OF_COLUMNS;
}({});
export const OptionsLayout = _ref => {
  let {
    numberOfColumns,
    children,
    ...rest
  } = _ref;
  const {
    isMobile
  } = useConfig();
  return /*#__PURE__*/React.createElement("div", _extends({
    className: classNames(styles.container, {
      [styles.oneColumn]: numberOfColumns === NUMBER_OF_COLUMNS.ONE || isMobile,
      [styles.twoColumns]: numberOfColumns === NUMBER_OF_COLUMNS.TWO && !isMobile,
      [styles.threeColumns]: numberOfColumns === NUMBER_OF_COLUMNS.THREE && !isMobile,
      [styles.freeFlow]: numberOfColumns === NUMBER_OF_COLUMNS.FREE_FLOW
    })
  }, rest), children);
};
//# sourceMappingURL=options-layout.js.map